import React, { useState, useMemo, useCallback } from "react";
import cls from './style.module.scss';
import useStyles from "isomorphic-style-loader/useStyles";
import { Iconfont } from "../../../../../../../../components/icon/iconfont";
import { BigButton } from "../../../../../../../../components/button";
import ReturnOrderLayout from "../components/layout";
import Toast from "../../../../../../../../components/toast";
import { useIntl, FormattedMessage } from "react-intl";
import { Swiper, SwiperSlide } from 'swiper/react'


const ReturnReasonSelect = props =>{
    useStyles(cls);
    const { returnList, updateReturnList, onClose, setType, reasonList } = props;
    const [currentOrder, setCurrentOrder] = useState(returnList[0]);

    const Intl = useIntl();

    const activeCount = useMemo(() =>{
        let data = returnList.filter(item=>!!item.reason)
        return data.length;
    }, [returnList]);

    const handleChangeOrder = useCallback((product) =>{
        let data = { ...product, isActive: !product.isActive };

        setCurrentOrder(data);
        updateReturnList(data)
    }, []);

    const handleSelectReason = useCallback((cOrder, reason) =>{
        if(!cOrder){
            return false;
        }
        const data = { ...cOrder, reason: reason };
        setCurrentOrder(data);
        updateReturnList(data)
    }, []);

    const handleSubmit = useCallback((list, count) =>{
        if(list.length === count){
            // todo true
            setType(2);
        }else{
            let currentOrder = list?.find(item=>!!!item.reason);
            let data = { ...currentOrder, isActive: !currentOrder.isActive };
            setCurrentOrder(data);
            updateReturnList(data);
            Toast(Intl.formatMessage({ id: "select_reason_all_be_returned", defaultMessage: "Please select the reason for all items to be returned" }));
        }
    }, []);

    return <ReturnOrderLayout
        topSlot={<span><FormattedMessage id="please_select_the_reason" defaultMessage="Please select the reason" /> ({activeCount}/{returnList.length})<span style={{ color: '#E64545' }}>*</span></span>} 
        bottomSlot={<BigButton onClick={()=>handleSubmit(returnList, activeCount)}><FormattedMessage id="next" defaultMessage="next" /></BigButton>} 
        onClose={onClose} 
    >
        <div className={cls.ReasonProducts}>
            <Swiper
                spaceBetween={20}
                slidesPerView='auto'
            >
                {
                    returnList?.map((product, index) => <SwiperSlide className={cls.EditorDisplayImage} key={index+product?.variantId+product.isActive} onClick={()=>handleChangeOrder(product)}>
                        <a className={`${cls.ReasonProduct}`}>
                            <div className={`${cls.Image} ${product.variantId===currentOrder?.variantId?cls.Active:""}`}>
                                <img src={product?.imageURL} alt="" />
                            </div>

                            <Iconfont 
                                className={`${cls.SelectLabel} ${!!product.reason ? cls.Active : ""}`} 
                            >&#xe65a;</Iconfont>
                        </a>
                    </SwiperSlide>)
                }
            </Swiper>
        </div>

        <div className={cls.ReasonContainer}>
            <div className={cls.ReasonList}>
                {
                    reasonList?.map((reason, index) =>(
                        <a className={cls.Reason} key={reason?.value+index} onClick={()=>handleSelectReason(currentOrder, reason)}>
                            <span className={cls.Label}>{reason.label}</span>

                            <span className={`${cls.Select} ${reason.value === currentOrder?.reason?.value?cls.Active:""}`}></span>
                        </a>
                    ))
                }
            </div>
        </div>
    </ReturnOrderLayout>
}

export default ReturnReasonSelect;